/**
 * 题目表单
 * @description 题目新增、编辑
 * @author mll
 * @date 2020-1-22
 */
import React, {Component} from 'react';
import moment from 'moment'
import PropTypes from 'prop-types';
import {Form, Cascader} from 'antd'
import {formValidator, numberValidator, authValidator, outputClassValidator, options, _tableFormProps} from "./config";

import {component_tool, framework_tool} from '@/tool'
import $$ from 'cmn-utils';

let {WizAvatarUpload, ossFileUtils} = framework_tool
let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizSwitch,
  WizDatePicker,
  WizRow,
  WizCol,
  WizRadio,
  Wizmessage,
  WizCheckbox,
  WizInputNumber
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup
import {WizTableForm, WizAuthority} from '@/containers/common';


/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class TaskForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      bizType: props.data['bizType'],
      propsInit: false,
      bizChange: false,
      date: new Date().getTime()
    }
  }

  componentDidMount() {
    let {data, form} = this.props;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps['data']) {
      if (nextProps['data']['bizType'] || nextProps['data']['bizType'] == 0) {
        if (!nextState['propsInit']) {
          nextState['bizType'] = nextProps['data']['bizType']
          nextState['propsInit'] = true
        }
      }
      if (nextProps['data'] && nextProps['data']['id']) {
        nextState['data']['id'] = nextProps['data']['id']
        nextState['data']['img'] = nextProps['data']['img']
      }
    }

    return true
  }


  /**
   * 数据校验方法
   */
  targetScopeValidator = (rule, value, callback) => {
    if (!value) {
      callback('请选择适用范围');
      return;
    }
    if (!value['orgIds'] || (value['orgIds'] && !value['orgIds'].length)) {
      callback('请选择品牌');
      return;
    }
    if (!value['positionCategoryIds'] || (value['positionCategoryIds'] && !value['positionCategoryIds'].length)) {
      callback('请选择岗位分类');
      return;
    }
    callback();
  }

  trainCenterIdValidator = (rule, value, callback) => {
    if (!value) {
      callback('请选择培训中心');
    }
    callback();
  }

  bizIdValidator = (rule, value, callback) => {

    let bizType = this.props.form.getFieldValue("bizType")
    if (bizType && !value) {
      callback('选择实体类型后请选择实体');
    }
    callback();
  }

  // 添加复选框状态发生变化
  handleCheckboxOnChange = (e) => {
    let {data} = this.state
    data.status = e.target.checked ? 1 : 0
    this.setState({data: data, date: new Date().getTime()})
  };

  /**
   * 表单基础内容
   */
  _base() {
    const {data, form} = this.props;
    let {getFieldDecorator} = form;
    let bizId = form.getFieldValue("bizId") || data.bizId || 0
    let bizType = form.getFieldValue("bizType") || data.bizType || 0
    let {allowOrder, bizChange, date} = this.state;
    let bizTypeName = ''
    let startDateName = ''
    let endDateName = ''
    //bizType切换后值清空
    let initRows = []
    if (this.state.bizType == 1||this.state.bizType == 2) {
      initRows = [{id: data.bizId, title: data.bizName}]
      bizTypeName = 'title'
      startDateName = 'startDate'
      endDateName = 'endDate'
    } else if (this.state.bizType == 15) {
      initRows = [{id: data.bizId, name: data.bizName}]
      bizTypeName = 'name'
      startDateName = 'startTime'
      endDateName = 'endTime'
    } else {
      initRows = [{id: data.bizId, name: data.bizName}]
      bizTypeName = 'name'
      startDateName = 'startDate'
      endDateName = 'endDate'
    }

    let disabled = false
    console.log(form.getFieldValue("bizType"),'form.getFieldValue("bizType")')
    if (data && data.id) {
      disabled = true
    }

    let enableItem = [
      <Item label="关联类型">
        {getFieldDecorator('bizType', {
          rules: [{required: true, message: "请选择关联类型"}],
          initialValue: this.state.bizType,
        })(
          <WizSelect
            placeholder="关联类型"
            allowClear={true}
            disabled = {disabled}
            onChange={(bizType) => {
              if (bizType || bizType == 0) {
              } else {
                form.setFieldsValue({bizId: null})
              }
              this.setState({bizType: bizType, bizChange: true})
            }}
          >
            <Option value={0}>课程</Option>
            <Option value={2}>问卷</Option>
            <Option value={1}>考试</Option>
            <Option value={26}>直播</Option>
            <Option value={15}>报名</Option>
            <Option value={36}>班级</Option>
            <Option value={59}>练习</Option>
            <Option value={45} disabled={true}>班级环节</Option>
            {/* <Option value={47} disabled={true}>远程评估</Option> */}
            {/* <Option value={20} disabled={true}>内容通知</Option> */}
          </WizSelect>,
        )}
      </Item>,
      <Item label="关联内容">
        {getFieldDecorator('bizId', {
          rules: [{required: true, validator: this.bizIdValidator}],
          initialValue: data.bizId,
        })(
          <WizTableForm
            key={this.state.bizType + '@' + date}
            {..._tableFormProps(this.state.bizType)}
            selectType={'radio'}
            disabled={disabled||!form.getFieldValue("bizType")&&form.getFieldValue("bizType")!=0}
            onChangeRowMap={(rowKey) => {
              let val;
              let startDate;
              let endDate;
              for (i in rowKey) {
                if (rowKey[i] != null) {
                  val = rowKey[i][bizTypeName]
                  startDate = rowKey[i][startDateName] && moment(rowKey[i][startDateName], 'YYYY-MM-DD HH:mm:ss') || null
                  endDate = rowKey[i][endDateName] && moment(rowKey[i][endDateName], 'YYYY-MM-DD HH:mm:ss') || null
                  data.img = rowKey[i].imgOne || rowKey[i].img || null
                }
              }
              this.props.form.setFieldsValue({
                name: val,
                startDate: startDate,
                endDate: endDate
              })
            }}
            initRows={initRows}
          />
        )}
      </Item>,
      <Item label="任务名称">
        {getFieldDecorator('name', {
          rules: [{required: true, message: "请输入任务名称"}],
          initialValue: data.name,
        })(<WizInput maxLength={30} placeholder='请输入任务名称,最多30字'/>)}
      </Item>,
      <Item label="开始时间">
        {getFieldDecorator('startDate', {
          rules: [{required: true, message: '请选择开始时间',}],
          initialValue: data.startDate && moment(data.startDate, 'YYYY-MM-DD HH:mm:ss')
            || null
        })(<WizDatePicker key='startDate' showTime placeholder="请选择开始时间" format="YYYY-MM-DD HH:mm"/>)}
      </Item>,
      <Item label="结束时间">
        {getFieldDecorator('endDate', {
          rules: [{required: true, message: '请选择结束时间',}],
          initialValue: data.endDate && moment(data.endDate, 'YYYY-MM-DD HH:mm:ss')
            || null
        })(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" format="YYYY-MM-DD HH:mm"/>)}
      </Item>,
      <Item label={ <span>
                        封面&nbsp;
                        <WizTooltip title="请上传大小不超过2MB,图片尺寸建议400*207">
                            <WizIcon type="question-circle-o" />
                        </WizTooltip>
                  </span>
      }>
        {getFieldDecorator('coverImg', {
          initialValue:
            (data && data.img) ? [
              {fileId: data.img}
            ] : []
        })(
          <WizAvatarUpload
            key={data && data.img || ''}
            accept={'.jpg, .jpeg, .png'}
            listType={'picture-card'}
            aspectRatio={400 / 207}
            beforeUpload={(file) => {
              let result = true;
              const isLt1M = file.size / 1024 / 1024 < 2;
              if (file.type.indexOf('image/') == -1) {
                Wizmessage.error('只能上传图片类型,请重新选择!');
                result = false;
              } else if (!isLt1M) {
                Wizmessage.error('图片不得超过2MB!');
                result = false;
              }
              return result;
            }}
          />
        )}
      </Item>,
      <Item label="重要程度">
        {getFieldDecorator('importance', {
          initialValue: data.importance || 0
        })(
          <WizRadio.Group>
            <WizRadio value={0}>重要</WizRadio>
            <WizRadio value={1}>一般</WizRadio>
          </WizRadio.Group>,
        )}
      </Item>,
    ]
    if (data && data.id) {
      let flag = data.status === 1
      enableItem.push(
        <Item label="启用">
          {getFieldDecorator('status', {
            initialValue: data.status || 0
          })(
            <WizCheckbox defaultChecked={flag}
                         onChange={this.handleCheckboxOnChange}/>
          )}
        </Item>,
      )
    }
    return enableItem
  }

  handleReset = () => {
    //重置表单
    this.setState({
      propsInit: false,
      bizChange: false,
      date: new Date().getTime()
    })
    this.props.form.resetFields();
  };

  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{span: 12, offset: 6}}>
        <WizRow>
          <WizCol span={24} style={{textAlign: 'center'}}>
            <WizButton type="primary" htmlType="submit">
              保存
            </WizButton>
            <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>
              重置
            </WizButton>
          </WizCol>
        </WizRow>
      </Item>
    )
  }


  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    const {data} = this.state
    let {submit} = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let coverImg = values['coverImg']
        values['id'] = data && data['id'] || null
        values['startDate'] = values['startDate'] && values['startDate'].format('YYYY-MM-DD HH:mm:ss')
        values['endDate'] = values['endDate'] && values['endDate'].format('YYYY-MM-DD HH:mm:ss')
        values['status'] = data && data.status !== 1 ? 0 : 1
        values['needNotice'] = data.needNotice
        if (values['endDate'] < values['startDate']) {
          wizNotice.error("结束时间不能早于开始时间")
        } else {
          if (coverImg && coverImg.length) {
            values['img'] = coverImg[0]['fileId']
            delete values['coverImg']
          }
          submit && submit(values)
        }
      }
    });
  };

  render() {

    let {data} = this.props;
    let outputClass = this.props.form.getFieldValue("outputClass")
    let extOptions = [];
    if (outputClass && outputClass instanceof Array && outputClass.length > 0) {
      outputClass.map(p => extOptions.push(p))
    }
    const formItemLayout = {
      labelCol: {span: 6},
      wrapperCol: {span: 14},
    };
    return (
      <WizForm
        {...formItemLayout}
        onSubmit={this.handleSubmit}
      >
        {this._base()}
        {this._submit()}
      </WizForm>
    )

  }
}

export default WizForm.create()(TaskForm);

/**
 * 默认值
 */
TaskForm.defaultProps = {
  // title: '新增题目',
  data: {},
  selects: []
}

/**
 * props入参校验
 */
TaskForm.propTypes = {}

